import { Package } from '@features/DynamicPackagesConfigurationWizard/types';
import { TranslationKey } from '@lang';

export type PackageInclusion = 'room' | 'spa' | 'dining';

export const inclusionLabelKeys: Record<PackageInclusion, TranslationKey> = {
  room: 'common.room',
  spa: 'common.spa',
  dining: 'common.dining',
};

type PackageExperience = NonNullable<Package['experiences']>[number];

export const isSpaExperience = (experience: PackageExperience) =>
  !!experience.options?.some((option) => option.itemType !== 'spa-extras');

const hasSpaExperience = (packageData: Package) => !!packageData.experiences?.some(isSpaExperience);

export const getRateInclusions = (packageData?: Package | null): PackageInclusion[] => {
  const inclusions: PackageInclusion[] = ['room'];

  if (!packageData) return inclusions;

  if (hasSpaExperience(packageData)) inclusions.push('spa');
  if (packageData.restaurants?.length) inclusions.push('dining');

  return inclusions;
};

export const getPackageInclusions = (packageData?: Package | null): PackageInclusion[] => {
  if (!packageData) return [];

  const inclusions = getRateInclusions(packageData);

  return inclusions.length > 1 ? inclusions : [];
};
